<template>
  <div class="page-view">
    <div class="page-wrap">
      <el-pagination
        class="page-com"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
        :total="total"
        :page-size="pageSize"

        :page-sizes="pageSizes"

        @size-change="sizeChange"
        @current-change="currentChange"
        @prev-click="currentChange"
        @next-click="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
// 封装的page组件 需传入total多少条？ offset第几页 注意 父级页面的初始化方法名字必须是handleSizeChange
export default {
  props: {
    pageSize: {
      type: Number,
      default: () => {
        return 10
      }
    },
    total: {
      type: Number,
      default: () => {
        return 1
      }
    },
    currentPage: {
      type: Number,
      default: () => {
        return 1
      }
    },
    pageSizes: {
      type: Array,
      default: () => {
        return [10, 20, 30, 40, 50]
      }
    },
    sizeChange: {
      type: Function,
      default: (pageSize) => {
      }
    },
    currentChange: {
      type: Function,
      default: (currentPage) => {
      }
    },
    prevClick: {
      type: Function,
      default: (currentPage) => {
      }
    },
    nextClick: {
      type: Function,
      default: (currentPage) => {
      }
    }
  },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>

::v-deep {

  .page-view {

  }

  .page-wrap {

  }

  .page-com {
    text-align: center;

    .btn-next,.btn-prev {
      background: #fff;
      background: rgba(255,255,255,0.8);
    }

    .el-pagination__sizes {
      display: none;
    }

    .el-pagination__jump {
      display: none;
    }

  }


}


@media screen and (min-width: 320px) { 

}

@media screen and (min-width: 480px) { 
    
}
/* 移动 */
@media screen and (min-width: 576px) { 
    
}
/* 平板 */
@media screen and (min-width: 768px) {
  
::v-deep {
  .page-com {
    text-align: center;

    .btn-next,.btn-prev {
      background: #fff;
      background: rgba(255,255,255,0.8);
    }

    .el-pagination__sizes {
      display: inline-block;
    }

    .el-pagination__jump {
      display: inline-block;
    }

  }
}

}

/* PC */
@media screen and (min-width: 992px) {

}
@media screen and (min-width: 1200px) {

}


</style>
